import React from 'react';
export function Footer() {
  return <footer className="w-full bg-ink-deep text-white" data-id="element-101" data-mp="32wd2qgad7ltj">
      <div className="max-w-3xl mx-auto px-5 py-12 text-center" data-id="element-102" data-mp="3gfsp4jdu96q5">
        <h3 className="font-display text-2xl font-bold tracking-tight text-white" data-id="element-103" data-mp="3gh3rcermy6f5">
          Aerial <span className="italic text-amber" data-id="element-104" data-mp="32lrm3dfusxjz">Class Ready</span>
        </h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-white/70" data-id="element-105" data-mp="36pzatambadi7">
          A full year of done-for-you class plans, skill progressions &amp; choreography for silks, hoop &amp; trapeze.
        </p>

        <div className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-1 text-[13px] text-white/70" data-id="element-106" data-mp="387ejk1577e7">
          <a href="mailto:help@iclcollective.com" className="inline-flex min-h-[44px] items-center px-1 hover:text-white hover:underline" data-id="element-107" data-mp="3ldu8l5f6f825">
            help@iclcollective.com
          </a>
        </div>

        <p className="mx-auto mt-7 max-w-2xl border-t border-ink-line pt-5 text-xs leading-relaxed text-white/45" data-id="element-108" data-mp="29xvpe8qab5n7">
          Aerial Class Ready is a class-planning resource for aerial arts
          instructors. It is not affiliated with or endorsed by any studio,
          training program or governing body. It does not replace instructor
          certification, first-aid training, or your own safety judgement: the
          instructor remains responsible for rigging, spotting and assessing each
          student. Content is kept within recreational beginner-to-intermediate
          scope and is not medical advice. Results depend on the instructor and
          the group; no specific outcome is guaranteed. © Aerial Class Ready 2026
          — All rights reserved.
        </p>
      </div>
    </footer>;
}